<template>
    <v-dialog v-model="dialog" width="500" scrollable>
        <template v-slot:activator="{ on }">
            <v-btn color="primary" v-on="on">Новый сценарий</v-btn>
        </template>

        <v-card class="pa-2">
            <v-card-title class="pa-0 pl-1 pb-5 text-left font-weight-medium" primary-title>Номер:</v-card-title>
            <v-card-text class="pa-0 px-3 text-left">
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    v-model="phone_first"
                                    :error-messages="phone_firstErrors"
                                    :counter="40"
                                    label="Сценарий для номера:"
                                    required
                                    @input="$v.phone_first.$touch()"
                                    @blur="$v.phone_first.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    v-model="wait_first"
                                    label="Время ожидание первого номера:"
                                    max="300"
                                    min="5"
                                    step="5"
                                    type="number"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    v-model="phone_second"
                                    :error-messages="phone_secondErrors"
                                    :counter="40"
                                    label="Второй номер:"
                                    required
                                    @input="$v.phone_second.$touch()"
                                    @blur="$v.phone_second.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    v-model="wait_second"
                                    label="Время ожидание второго номера:"
                                    max="300"
                                    min="0"
                                    step="5"
                                    type="number"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    v-model="phone_third"
                                    :error-messages="phone_thirdErrors"
                                    :counter="40"
                                    label="Третий номер:"
                                    required
                                    @input="$v.phone_third.$touch()"
                                    @blur="$v.phone_third.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    v-model="wait_third"
                                    label="Время ожидание третьего номера:"
                                    max="300"
                                    min="0"
                                    step="5"
                                    type="number"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    v-model="phone_fourth"
                                    :error-messages="phone_fourthErrors"
                                    :counter="40"
                                    label="Четвертый номер:"
                                    required
                                    @input="$v.phone_fourth.$touch()"
                                    @blur="$v.phone_fourth.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    v-model="wait_fourth"
                                    label="Время ожидание четвертого номера:"
                                    max="300"
                                    min="0"
                                    step="5"
                                    type="number"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>

            <v-card-actions class="buttons-group justify-end pa-0 pt-3">
                <v-btn
                        class="primary text--darken-4 py-2 px-4"
                        small
                        height="auto"
                        dark
                        @click="deleteExtension()"
                >Удалить
                </v-btn>
                <v-btn
                        class="primary text--darken-4 py-2 px-4"
                        small
                        height="auto"
                        dark
                        @click="close()"
                >Закрыть
                </v-btn>
                <v-btn
                        class="primary text--darken-4 py-2 px-4"
                        small
                        height="auto"
                        dark
                        @click="save()"
                >Сохранить
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    import axios from 'axios'
    import { validationMixin } from 'vuelidate'
    import { required, maxLength } from 'vuelidate/lib/validators'

    export default {
        name: 'CallForwardingModal',

        mixins: [validationMixin],

        validations: {
            phone_first: {required, maxLength: maxLength(40)},
            phone_second: {maxLength: maxLength(40)},
            phone_third: {maxLength: maxLength(40)},
            phone_fourth: {maxLength: maxLength(40)},
        },

        props: {
            object_id: {
                default: -1,
            },
        },

        data: () => ({
            dialog: false,

            id_extension: 0,
            phone_first: '',
            wait_first: 5,
            phone_second: '',
            wait_second: 10,
            phone_third: '',
            wait_third: 10,
            phone_fourth: '',
            wait_fourth: 10,
        }),

        watch: {
            object_id: function () {
                console.log('watch(): ' + this.object_id)

                if (this.object_id > 0){
                    this.id_extension = this.object_id
                    this.getExtension(this.id_extension)
                }
            },
        },

        computed: {
            phone_firstErrors() {
                const errors = [];
                if (!this.$v.phone_first.$dirty) return errors;
                !this.$v.phone_first.maxLength && errors.push('Максимальная длинна 40 символов.');
                !this.$v.phone_first.required && errors.push('Не должен быть пустым.');
                return errors;
            },
            phone_secondErrors() {
                const errors = [];
                if (!this.$v.phone_second.$dirty) return errors;
                !this.$v.phone_second.maxLength && errors.push('Максимальная длинна 40 символов.');
                return errors;
            },
            phone_thirdErrors() {
                const errors = [];
                if (!this.$v.phone_third.$dirty) return errors;
                !this.$v.phone_third.maxLength && errors.push('Максимальная длинна 40 символов.');
                return errors;
            },
            phone_fourthErrors() {
                const errors = [];
                if (!this.$v.phone_fourth.$dirty) return errors;
                !this.$v.phone_fourth.maxLength && errors.push('Максимальная длинна 40 символов.');
                return errors;
            },
        },

        methods: {
            /**
             * Получить сценарий для редактирования.
             *
             * @param id_extension
             */
            getExtension(id_extension) {
                axios({
                    method: 'get',
                    url: process.env.VUE_APP_API_URL_PHONE + 'get-сall-forwarding',
                    params: {
                        id_extension: id_extension
                    },
                }).then((response) => {

                    //console.log(response.data);

                    this.id_extension = response.data.id;
                    this.phone_first = response.data.phone_first;
                    this.wait_first = response.data.wait_first;
                    this.phone_second = response.data.phone_second;
                    this.wait_second = response.data.wait_second;
                    this.phone_third = response.data.phone_third;
                    this.wait_third = response.data.wait_third;
                    this.phone_fourth = response.data.phone_fourth;
                    this.wait_fourth = response.data.wait_fourth;

                }).catch(error => alert(error));

                this.dialog = true
            },

            /**
             * Удалить сценарий.
             */
            deleteExtension() {

                axios({
                    method: 'post',
                    url: process.env.VUE_APP_API_URL_PHONE + 'delete-сall-forwarding',
                    params: {
                        id_extension: this.id_extension,
                    },
                }).then((response) => {
                    console.log(response.data);
                }).catch(error => alert(error));

                this.close()
            },

            /**
             *  Сохранить сценарий.
             */
            save() {
                this.$v.$touch();

                if (!this.$v.$invalid) {

                    axios({
                        method: 'post',
                        url: process.env.VUE_APP_API_URL_PHONE + 'set-сall-forwarding',
                        params: {
                            id_extension: this.id_extension,
                            phone_first: this.phone_first,
                            wait_first: this.wait_first,
                            phone_second: this.phone_second,
                            wait_second: this.wait_second,
                            phone_third: this.phone_third,
                            wait_third: this.wait_third,
                            phone_fourth: this.phone_fourth,
                            wait_fourth: this.wait_fourth,
                        },
                    }).then((response) => {
                        console.log(response.data);
                    }).catch(error => alert(error));

                    this.close();
                }
            },

            /**
             * Закрыть модальное окно для редактирования сценария и обнулить поля.
             */
            close() {
                this.dialog = false;

                this.$v.$reset();
                this.id_extension = 0;
                this.phone_first = '';
                this.wait_first = 5;
                this.phone_second = '';
                this.wait_second = 10;
                this.phone_third = '';
                this.wait_third = 10;
                this.phone_fourth = '';
                this.wait_fourth = 10;

                this.$emit('closeModal');
            },
        },
    }

</script>

<style scoped>
</style>
